import { Option } from '@g17eco/types/valueList';
import { normalizeText } from '@utils/string-format';

export const isDuplicatedOption = (options: Option[], option: Option) => {
  return options.some((op) => normalizeText(op.name) === normalizeText(option.name) || op.code === option.code);
};
